import OnedioEventTracker from '@onedio/event-tracker';
import { HOST_URL, LINK_PROD, ONEDIO_ANALYTICS_URL, RECO_URL, RECOMMENDATION_PRODUCT } from '~/constants/config';

const isProdOnedio = HOST_URL === LINK_PROD;
const oet = new OnedioEventTracker({
  eventTrackerAPI: ONEDIO_ANALYTICS_URL,
  recommendationAPI: RECO_URL,
  isProd: isProdOnedio,
  product: RECOMMENDATION_PRODUCT,
});
const oetFuncObject = {
  pushEvent: ({ userId, eventType, itemId, itemType, itemMetadata }) => {
    oet.pushEvent({ userId, eventType, itemId, itemType, itemMetadata });
  },
  sendPushNotificationPlatformInformations: async ({ userId, notificationTargetValue, externalPlatform, notificationTargetType } = {}) => {
    try {
      await oet.sendPushNotificationPlatformInformations({
        userId,
        externalPlatform,
        notificationPlatform: 'web',
        notificationTargetType,
        notificationTargetValue,
        recommendationAPIVersion: 'v1',
        requestTimeout: 5000,
      });
    } catch (error) {
      console.log('error: ', error);
    }
  },
  getOetObject: () => oet,
  setDebugMode: (debugMode) => (oet.debugMode = debugMode),
  setIsAllowed: (isAllowed) => (oet.isAllowed = isAllowed),
};

export default ({ res }, inject) => {
  inject('oet', oetFuncObject);
};
